var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.messages),function(message){return _c('ChatListElement',{key:message.id,attrs:{"message":message}})}))}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChatList.vue?vue&type=template&id=0b964b6b
// module id = lllJ
// module chunks = 1